//------------------------------------------------------------------------------
// name: status.ts
// author: mudas
// created: 2025/12/19
//------------------------------------------------------------------------------

export enum FeedbackStatus {
  // 待处理
  PENDING = 0,
  // 已解决
  RESOLVED = 1,
}

export const FeedbackStatusName = {
  [FeedbackStatus.PENDING]: '待处理',
  [FeedbackStatus.RESOLVED]: '已解决',
};